<div soho-widget
    widgetHeight="{{panel.widgetHeight}}"
    widgetWidth="{{panel.widgetWidth}}"
    attr.data-automation-id="lm-{{panel.automationId}}-widget"
>

  <div soho-widget-header>
    <h2 soho-widget-title
        tabIndex="0"
        [ngStyle]="{'display': 'inline-block'}"
        [ngClass]="{'hasOverviewClass': (hasOverviewNavigation && displayLinkAsText) }"
        soho-tooltip [content]="panel.title"
        attr.id="{{panel.id}}_widget_title"
        attr.data-automation-id="lm-{{panel.automationId}}-widget-title"
    >{{panel.title}}</h2>
    <div class="panelNavigation">
      <button *ngIf="hasOverviewNavigation && !displayLinkAsText"
          soho-button="icon"
          icon="right-arrow"
          soho-tooltip [content]="overNavigationLink"
          (click)="onNavigationClick()"
          attr.id="{{panel.id}}_overview_navigation"
          attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
      ></button>
      <a *ngIf="hasOverviewNavigation && displayLinkAsText"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          attr.aria-label="{{panel.title}} - {{overNavigationLink}}"
          soho-hyperlink
          class="lm-hyperlink"
          (click)="onNavigationClick()"
          (keydown.enter)="onNavigationClick()"
          soho-tooltip [content]="overNavigationLink"
          attr.id="{{panel.id}}_overview_navigation"
          attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
      >{{overNavigationLink}}</a>
    </div>
  </div>

  <div soho-widget-content *ngIf="panel.formSpec && fromDataView && panel.type !== 'menuPanel'">
    <!-- I believe we dont' allow related OTO data in a form detail section/dashboard/etc. Not completely sure. -->
    <ng-container *ngIf="!panel.onCompositeForm">
      <lm-form #LMFormComponent
          [formUrlInfo]="formUrlInfo"
          [formSpec]="panel.formSpec"
          [fromDataView]="fromDataView"
          [formOptions]="{isDashBoardContent: true}"
          (formRendered)="onFormRendered()"
          [ngStyle]="{'padding-top': '10px'}">
      </lm-form>
    </ng-container>
    <ng-container *ngIf="panel.onCompositeForm && panel.type != 'independentform'">
      <lm-form-layout #LMFormComponent
          [formSpec]="panel.formSpec"
          [layout]="panel.layout"
          [formOptions]="{isDashBoardContent: true}"
          [model]="model"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          (dataViewLoaded)="onFormRendered()"
          (fieldEvent)="onFieldEvent($event)"
          [ngStyle]="{'padding': '10px 0px 10px 10px'}">
        </lm-form-layout>
    </ng-container>
    <ng-container *ngIf="panel.onCompositeForm && panel.type == 'independentform'">
      <lm-form #LMFormComponent
          [formUrlInfo]="formUrlInfo"
          [formSpec]="panel.formSpec"
          [fromDataView]="fromDataView"
          [formOptions]="{isDashBoardContent: true}"
          (formRendered)="onFormRendered()"
          [ngStyle]="{'padding': '10px 0px 0px 10px'}">
      </lm-form>
    </ng-container>
  </div>

  <div soho-widget-content *ngIf="panel.formSpec && panel.type === 'menuPanel'">
    <!-- todo: not sure formUrlInfo is even needed for form panels in a widget
           for a composite form that implements DashboardView.
    -->
    <lm-form #LMFormComponent
        [formUrlInfo]="formUrlInfo"
        [formSpec]="panel.formSpec"
        [initDataView]="initDataView"
        [formOptions]="{isDashBoardContent: true}"
        (formRendered)="onFormRendered()"
    ></lm-form>
  </div>
</div>
